<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1">
<p class="subtitle">Casemate Short History</p>
<h1 class="title">AMPHIBIOUS WARFARE</h1>
<div class="img_container1"><img alt="image" src="images/Img_0001-01.jpg"/></div>
<p class="author">Oscar E. Gilbert and Romain V. Cansière</p>
<div class="pub"><img alt="image" src="images/pub.jpg"/>
<p class="center"><em class="italic">Oxford &amp; Philadelphia</em></p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?c28193d4